import { TTFormInputProps } from "./input.types";
import { InputBase } from "./InputBase";

export const InputText = (props: TTFormInputProps) => <InputBase {...props} />;
